<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || routeName==='profile_super'">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-buttons v-if="routeName != 'profile_super'" slot="end">
                <ion-button class="pill next-pill-button" @click="skip">
                    <span>Skip</span>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container">
                <PageTitle :title="pageText.pageTitle" :subtitle="pageText.formText" showIcon />
                <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                    :ref="el => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')"
                    @keyup.enter="save('userForm')">
                    <div class="form_text" v-if="$route.name != 'auth_billing_name'">
                        <div class="text">
                        </div>
                    </div>
                    <el-form-item prop="type">
                        <el-select class="covid-cert-select" style="width: 100%" v-model="formsData.userForm.type.value"
                            @change="setFundTypeAndAssignNewKeys($event)" placeholder="Select Fund Type">
                            <el-option label="Industry Super Fund" :value="2" />
                            <el-option label="Self Managed Super Fund" :value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="What is the name of your Super fund?" class="no-scroll" prop="superfund">
                        <el-input @input="fixValidation" v-model="formsData.userForm.superfund.value" autocomplete="off"
                            placeholder="Fund Name">
                        </el-input>
                    </el-form-item>
                    <div class="form_text">
                        <div class="text text-sm ">
                            What is your legal name registered with the Super fund?
                        </div>
                    </div>
                    <el-form-item label="Title" class="no-scroll" prop="title" :required="true">
                        <el-select popper-class="normal-select" class="w-100"
                            v-model="formsData.userForm.title.value" placeholder="Select title"
                            @change="fixValidation">
                            <el-option label="Mr" value="Mr" />
                            <el-option label="Ms" value="Ms" />
                            <el-option label="Mrs" value="Mrs" />
                            <el-option label="Dr" value="Dr" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="First Name" class="no-scroll" prop="first_name" :required="true">
                        <el-input @input="fixValidation" v-model="formsData.userForm.first_name.value" autocomplete="off"
                            placeholder="First Name">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="Last Name" class="no-scroll" prop="last_name" :required="true">
                        <el-input @input="fixValidation" v-model="formsData.userForm.last_name.value" autocomplete="off"
                            placeholder="Last Name">
                        </el-input>
                    </el-form-item>
                    <div class="form_text">
                        <div class="text text-sm ">
                            What is your Date Of Birth?
                        </div>
                    </div>
                    <el-form-item prop="birthday" :required="true">
                        <el-date-picker popper-class="datepicker_popper drawer-style"
                            v-model="formsData.userForm.birthday.valueFormatted" type="date" placeholder="Date of Birth"
                            :format="$filters.systemDateFormat()" :editable="false" :disabled-date="formsData.userForm.birthday.disabledDate"
                            @change="dateConvert">
                        </el-date-picker>
                    </el-form-item>
                    <div class="form_text">
                        <div class="text text-sm ">
                            Superannuation standard choice form?
                        </div>
                    </div>
                    <el-form-item :required="false" v-if="files.length == 0">
                        <el-upload class="uploader-support super-uploader" :action="'upload'"
                            accept="image/*,application/pdf" name="files" list-type="picture" :thumbnail-mode="true"
                            :on-preview="cropperMethods.handlePreview" :limit="1" :on-exceed="cropperMethods.handleExceed"
                            :drag="true" :on-change="cropperMethods.handleChange"
                            :before-upload="cropperMethods.beforeAvatarUpload">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 1.66602V6.66602L11.6667 4.99935" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.0002 6.66667L8.3335 5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.83333 10C2.5 10 2.5 11.4917 2.5 13.3333V14.1667C2.5 16.4667 2.5 18.3333 6.66667 18.3333H13.3333C16.6667 18.3333 17.5 16.4667 17.5 14.1667V13.3333C17.5 11.4917 17.5 10 14.1667 10C13.3333 10 13.1 10.175 12.6667 10.5L11.8167 11.4C10.8333 12.45 9.16667 12.45 8.175 11.4L7.33333 10.5C6.9 10.175 6.66667 10 5.83333 10Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.1665 10.0005V6.66719C4.1665 4.99219 4.1665 3.60885 6.6665 3.36719" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.8335 10.0005V6.66719C15.8335 4.99219 15.8335 3.60885 13.3335 3.36719" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                            <div class="el-upload__text ml-2">
                                Upload File
                            </div>
                            <template #file="{ file }">
                                <div v-if="file.raw.type=='application/pdf'" class="el-upload-list__item-body">
                                    <img class="el-upload-list__item-body-thumbnail" :src="require('@/assets/img/icons/pdf.svg')" />
                                    <div class="el-upload-list__item-body-text">
                                        <span class="title" size="large">{{ file.name }}</span>
                                        <span class="description" size="large">{{ formatDate(file.lastModified) }}</span>
                                    </div>
                                </div>
                                <div class="el-upload-list__item-body" v-else>
                                    <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt=""/>
                                    <div class="el-upload-list__item-body-text">
                                        <span class="title" size="large">{{ file.name }}</span>
                                        <span class="description" size="large">{{ formatDate(file.lastModified) }}</span>
                                    </div>
                                </div>
                                <div class="el-upload-list__item-actions">
                                    <button class="el-upload-list__item-actions-action" @click="cropperMethods.handleRemove(file)">
                                        <img :src="require('@/assets/img/icons/trash.svg')" />
                                    </button>
                                </div>
                            </template>
                        </el-upload>
                    </el-form-item>
                    <div class="preview_square preview_square_super" v-if="files.length > 0">


                        <div class="el-upload-list">
                            <div class="el-upload-list__item" v-for="(file) in files" :key="file.url">
                                <div class="thumbnail_img el-upload-list--picture-card">
                                    <div v-if="file.extension == 'pdf'">
                                        <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">

                                    </div>
                                    <div v-else>
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                                    </div>

                                    <span class="el-upload-list__item-actions">
                                        <span class="el-upload-list__item-preview" @click="certPreviewModalOpen(file)">
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                        <span class="el-upload-list__item-delete" @click="fileDelete(file)">
                                            <i class="el-icon-delete"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <cert-preview-modal :modalName="'certPreviewModal'" :options="certPreviewModal" />
                    <el-form-item label="What is your Tax File Number (TFN)?" class="no-scroll" prop="tfn"
                        :required="isLocumAndSoleTrader">
                        <el-input @input="fixValidation" v-model="formsData.userForm.tfn.value" autocomplete="off"
                            placeholder="TFN">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="What is the ABN of your super fund?" prop="abn" :required="true">
                            <el-input @input="fixValidation"  @blur="fixValidation" v-model="formsData.userForm.abn.value" autocomplete="off"
                                maxlength="11" show-word-limit type="text" placeholder="Australian Business Number">
                            </el-input>
                        </el-form-item>

                    <!-- INDUSTRY FUND TYPE -->
                    <div v-if="formsData.userForm.type.value == 2">

                        <el-form-item label="What is the Unique Superannuation Identifier (USI) of your fund?"
                            class="no-scroll" prop="usi" :required="true">
                            <el-input @input="fixValidation" v-model="formsData.userForm.usi.value" autocomplete="off"
                                placeholder="Fund USI">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="What is your Superannuation Fund Member number?" class="no-scroll"
                            prop="membership_number" :required="true">
                            <el-input @input="fixValidation" v-model="formsData.userForm.membership_number.value"
                                autocomplete="off" placeholder="Membership Number">
                            </el-input>
                        </el-form-item>

                    </div>
                    <!-- SELF MANAGED FUND -->
                    <div v-if="formsData.userForm.type.value === 1">
                        
                        <el-form-item
                            label="What is the Electronic Service Address of the SMSF? (Please contact your account if you are unsure)"
                            class="no-scroll" prop="esa" :required="true">
                            <el-input @input="fixValidation" v-model="formsData.userForm.esa.value" autocomplete="off"
                                placeholder="ESA">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="What is the BSB of the SMSF?" class="no-scroll" prop="bsb" :required="true">
                            <el-input @input="fixValidation" v-model="formsData.userForm.bsb.value" autocomplete="off"
                                maxlength="6" show-word-limit type="text" placeholder="BSB">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="What is the account number of the SMSF bank account?" class="no-scroll"
                            prop="account_number" :required="true">
                            <el-input @input="fixValidation" v-model="formsData.userForm.account_number.value"
                                autocomplete="off" placeholder="Account Number">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="What is the account name of the SMSF bank account?" class="no-scroll"
                            prop="account_name">
                            <el-input @input="fixValidation" v-model="formsData.userForm.account_name.value"
                                autocomplete="off" placeholder="Account Name">
                            </el-input>
                        </el-form-item>
                    </div>

                    <div class="label-description">Please provide BPAY details for your Super Fund as some pharmacies prefer
                        to use this
                        payment method.</div>
                    <el-form-item label="BPay Number" class="no-scroll" prop="bpay_number">
                        <el-input @input="fixValidation" v-model="formsData.userForm.bpay_number.value" autocomplete="off"
                            placeholder="BPay Number">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="Customer reference Number" class="no-scroll" prop="customer_reference_number">
                        <el-input @input="fixValidation" v-model="formsData.userForm.customer_reference_number.value"
                            autocomplete="off" placeholder="Customer Reference Number">
                        </el-input>
                    </el-form-item>
                    <el-form-item class="button_submit mb0">
                        <el-button class="submit" type="blue" @click="save('userForm')"
                            :disabled="formsData.userForm.disabled">
                            Continue 
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="bg-overlay"></div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
    ref,
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'

import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import formMasks from "@/hooks/form/mask/mask";
import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";
import { CertPreviewModal } from "@/modals/modals";
import FileHelpers from "@/helpers/file/file";
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import PageTitle from '@/components/PageTitle/PageTitle.vue';
import moment from 'moment';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle,
        "cert-preview-modal": CertPreviewModal,
    },
    directives: {
        imask: IMaskDirective,
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject(['setPageClassGlobal']);

        const fileHelpers = new FileHelpers();
        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const userSuper = userData.locumSuper;
        const SUPER_TITLES = ['Mr', 'Ms', 'Mrs'];
        const parseSuperLegalName = (superRecord, profileData) => {
            let title = superRecord.title || '';
            let firstName = superRecord.firstName || '';
            let lastName = superRecord.lastName || '';

            if (!firstName && !lastName) {
                let remainder = (superRecord.fullName || profileData.name || '').trim();

                for (const candidateTitle of SUPER_TITLES) {
                    const prefix = `${candidateTitle} `;
                    if (remainder.startsWith(prefix)) {
                        title = candidateTitle;
                        remainder = remainder.slice(prefix.length).trim();
                        break;
                    }
                }

                const parts = remainder.split(' ');
                firstName = parts[0] || profileData.firstName || '';
                lastName = parts.slice(1).join(' ') || profileData.lastName || '';
            } else {
                firstName = firstName || profileData.firstName || '';
                lastName = lastName || profileData.lastName || '';
            }

            return { title, firstName, lastName };
        };
        const superLegalName = parseSuperLegalName(userSuper, userData);
        const isLocumAndSoleTrader = userRole == 'locum' && userData.billingAccountType === 2;
        const typeReactive = userData.locumSuper.type ? userData.locumSuper.type : 1;
        let superUserType = ref(typeReactive);
        const originalFundType = userSuper?.type ?? 1;
        const previousFundType = ref(originalFundType);
        const routeName = $route.name;
        const $moment = inject(["$moment"]);
        const $modals = inject("$modals");
        const certPreviewModal = ref({
            name: "certPrev",
            file: [],
        });
        const files = ref(userData.superDocument);
        console.log("file of load", files.value);
        const certPreviewModalOpen = (files) => {
            // const myFiles =  {url: files};
            if (files.extension == 'pdf') {
                window.open(files.url, "_blank");
            } else {
                certPreviewModal.value.file = files;
                $modals.open("certPreviewModal", {
                    file: files,
                });
            }
        };

        const pageText = {
            pageTitle: 'Super Details',
            formText: 'We will use this to create separate invoices for pharmacies to pay your Super',
        }

        const dateConvert = () => {
            if (formsData.userForm.birthday.valueFormatted) {
                const result = $moment(formsData.userForm.birthday.valueFormatted, "YYYY-MM-DD").format(
                    "YYYY-MM-DD")
                formsData.userForm.birthday.value = result
            } else {
                return null;
            }
        };

        const birthdayValue = userData.birthday
            ? $moment(userData.birthday, ["YYYY-MM-DD"])
            : new Date(new Date().setFullYear(new Date().getFullYear() - 21));

        const formsDataArray = {
            userForm: {
                isFormValid: true,

                type: {
                    value: userSuper.type ? userSuper.type : 1,
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'fundType', callback, setFormValidation);
                        },
                    }]
                },
                title: {
                    value: superLegalName.title,
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'title', callback, setFormValidation);
                        },
                    }],
                },
                first_name: {
                    value: superLegalName.firstName,
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'firstName', callback, setFormValidation);
                        },
                    }],
                },
                last_name: {
                    value: superLegalName.lastName,
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'lastName', callback, setFormValidation);
                        },
                    }],
                },
                birthday: {
                    value: userData.birthday ? userData.birthday : $moment((new Date(new Date().setFullYear(new Date().getFullYear() - 21))), "YYYY-MM-DD").format("YYYY-MM-DD"),
                    valueFormatted: birthdayValue,
                    disabledDate: (time) => {
                        let dateNow = new Date().setFullYear(new Date().getFullYear() - 18);
                        return (
                            time.getTime() >
                                new Date(dateNow).setDate(new Date(dateNow).getDate())
                        );
                    },
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "birthday",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                files: {
                    ref: null,
                    value: files.value ? files.value : [],
                },
                tfn: {
                    value: userSuper.tfn || "",
                    resetValue: true,
                },
                superfund: {
                    value: userSuper.superfund || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'preferredName', callback, setFormValidation);
                        },
                    }],
                },

                bpay_number: {
                    value: userSuper.bpayNumber || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'bpayNumber', callback, setFormValidation);
                        },
                    }],
                },
                customer_reference_number: {
                    value: userSuper.customerReferenceNumber || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'customerRefNumber', callback, setFormValidation);
                        },
                    }],
                },
                abn: {
                    value: userSuper.abn || "",
                    // value: $store.getters.getUserData.billing.abn || '14 069 979 460',
                    resetValue: true,
                    mask: formMasks.abn,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "abn",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };

        if (isLocumAndSoleTrader) {
            const dataArray = {
                tfn: {
                    value: userSuper.tfn || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'anyNumber', callback, setFormValidation);
                        },
                    }],
                },
            }
            Object.assign(formsDataArray.userForm, dataArray);
        }


        if (superUserType.value === 2) {
            const dataArray = {
                type: formsDataArray.userForm.type,
                title: formsDataArray.userForm.title,
                first_name: formsDataArray.userForm.first_name,
                last_name: formsDataArray.userForm.last_name,
                birthday: formsDataArray.userForm.birthday,
                files: formsDataArray.userForm.files,
                superfund: formsDataArray.userForm.superfund,
                bpay_number: formsDataArray.userForm.bpay_number,
                customer_reference_number: formsDataArray.userForm.customer_reference_number,
                tfn: formsDataArray.userForm.tfn,
                usi: {
                    value: userSuper.usi || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'usi', callback, setFormValidation);
                        },
                    }],
                },
                membership_number: {
                    value: userSuper.membershipNumber || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'anyNumber', callback, setFormValidation);
                        },
                    }],
                },
                abn:formsDataArray.userForm.abn,
                // abn: {
                //     value: userSuper.abn || "",
                //     // value: $store.getters.getUserData.billing.abn || '14 069 979 460',
                //     mask: formMasks.abn,
                //     validators: [
                //         {
                //             validator: (rule, formField, callback) => {
                //                 formValidate.validate(
                //                     rule,
                //                     formField,
                //                     "abn",
                //                     callback,
                //                     setFormValidation
                //                 );
                //             },
                //         },
                //     ],
                // },
            }
            Object.assign(formsDataArray.userForm, dataArray);
        }
        // SELF MANAGED FUND
        if (superUserType.value === 1) {
            const dataArray = {
                type: formsDataArray.userForm.type,
                title: formsDataArray.userForm.title,
                first_name: formsDataArray.userForm.first_name,
                last_name: formsDataArray.userForm.last_name,
                birthday: formsDataArray.userForm.birthday,
                files: formsDataArray.userForm.files,
                superfund: formsDataArray.userForm.superfund,
                bpay_number: formsDataArray.userForm.bpay_number,
                customer_reference_number: formsDataArray.userForm.customer_reference_number,
                tfn: formsDataArray.userForm.tfn,
                account_name: {
                    value: userSuper.accountName || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'preferredName', callback, setFormValidation);
                        },
                    }],

                },
                abn:formsDataArray.userForm.abn,
                // abn: {
                //     value: userSuper.abn || "",
                //     // value: $store.getters.getUserData.billing.abn || '14 069 979 460',
                //     mask: formMasks.abn,
                //     validators: [
                //         {
                //             validator: (rule, formField, callback) => {
                //                 formValidate.validate(
                //                     rule,
                //                     formField,
                //                     "abn",
                //                     callback,
                //                     setFormValidation
                //                 );
                //             },
                //         },
                //     ],
                // },
                esa: {
                    value: userSuper.esa || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'anyNumber', callback, setFormValidation);
                        },
                    }],
                },
                bsb: {
                    value: userSuper.bsb ? IMask.createMask(formMasks.bsb).resolve(userSuper.bsb)
                        : "",
                    mask: formMasks.bsb,
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, "bsbSuper", callback, setFormValidation);
                        },
                    }],
                },
                account_number: {
                    value: userSuper.accountNumber || "",
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'anyNumber', callback, setFormValidation);
                        },
                    }],
                },
            }
            Object.assign(formsDataArray.userForm, dataArray);
        }


        const cropperMethods = {
            beforeAvatarUpload(file) {
                const img = URL.createObjectURL(file.raw);
                console.log(img);
            },
            handleRemove(file) {
                formsData.userForm.files.splice(
                    formsData.userForm.files.indexOf(file),
                    1
                );
            },
            handleChange(file, files) {
                const type = fileHelpers.getFileType(file);
                console.log(type);
                if (type == "image" || type == "pdf") {
                    formsData.userForm.files = files;
                    formsData.userForm.files.value = files;

                    formsData.userForm.disabled = !formsData.userForm.isFormValid;


                } else {
                    files.pop();
                    formsData.userForm.files.value = [];
                    ElMessage({
                        type: "error",
                        message: `Certificate   must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
            },

            handlePreview(/*file*/) { },
            handleExceed(file, files) {
                console.log(file);
                ElMessage({
                    type: "error",
                    message: `You can upload 1 super compliance letter, you selected ${files.length} `,
                });
            },
        };

        const goBack = async() => {
            if (routeName == "profile_super") {
                $router.push({
                    name: "profile",
                });
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            }
        };

        const goNext = () => {
            if (userRole == 'locum') {
                if (userData.role === 'locum') {
                    $router.push({
                        name: "auth_gst",
                    });
                }

                // TODO: REBUILD
            }
        };

        const skip = () => {
            $store.dispatch('addAuthPageBack', $route.name);
            goNext()
        }

        const save = (formName) => {
            let data = { super: { ...getFormValues(formName) } }
            // Always send BPAY fields (backend expects them even when empty)
            data.super.bpay_number = data.super.bpay_number ?? '';
            data.super.customer_reference_number = data.super.customer_reference_number ?? '';
            const canvas = formsData.userForm.files.value;
            const form = new FormData();
            let counter = 0;

            // Append data values to FormData
            for (const key in data.super) {
                form.append(`super[${key}]`, data.super[key]);
            }

            if (canvas.length != 0) {
                canvas.map((item) => {
                    console.log("canvas", item);
                    form.append(`super[files][${counter}]`, item.raw);
                    counter++;
                });
            }
            console.log('form vitra ko ', form)
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            await $store.dispatch('SAVE_USER_DATA', form);
                            if (routeName == "profile_super") {
                                $router.push({
                                    name: "profile",
                                });
                            } else {
                                goNext()
                            }

                        } catch (error) {
                            console.log('error submit!!');
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log('error submit!!');
                    return false;
                }
            });
        }

        const setFundTypeAndAssignNewKeys = (eventValue) => {

            if (eventValue === 2 || eventValue === 0) {
                const dataArray = {
                    type: formsDataArray.userForm.type,
                    title: formsDataArray.userForm.title,
                    first_name: formsDataArray.userForm.first_name,
                    last_name: formsDataArray.userForm.last_name,
                    birthday: formsDataArray.userForm.birthday,
                    files: formsDataArray.userForm.files,
                    superfund: formsDataArray.userForm.superfund,
                    bpay_number: formsDataArray.userForm.bpay_number,
                    customer_reference_number: formsDataArray.userForm.customer_reference_number,
                    account_name: formsDataArray.userForm.account_name,
                    tfn: formsDataArray.userForm.tfn,
                    usi: {
                        value: userSuper.usi || "",
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'usi', callback, setFormValidation);
                            },
                        }],
                    },
                    membership_number: {
                        value: userSuper.membershipNumber || "",
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'anyNumber', callback, setFormValidation);
                            },
                        }],
                    },
                   abn:formsDataArray.userForm.abn,
                }
                for (const key in formsDataArray.userForm) {
                    delete formsDataArray.userForm[key]
                }
                Object.assign(formsDataArray.userForm, dataArray);
            }
            // SELF MANAGED FUND
            else {
                const dataArray = {
                    type: formsDataArray.userForm.type,
                    title: formsDataArray.userForm.title,
                    first_name: formsDataArray.userForm.first_name,
                    last_name: formsDataArray.userForm.last_name,
                    birthday: formsDataArray.userForm.birthday,
                    files: formsDataArray.userForm.files,
                    superfund: formsDataArray.userForm.superfund,
                    bpay_number: formsDataArray.userForm.bpay_number,
                    customer_reference_number: formsDataArray.userForm.customer_reference_number,
                    tfn: formsDataArray.userForm.tfn,
                    account_name: {
                        value: userSuper.accountName || "",
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'preferredName', callback, setFormValidation);
                            },
                        }],

                    },
                    abn:formsDataArray.userForm.abn,
                    esa: {
                        value: userSuper.esa || "",
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'anyNumber', callback, setFormValidation);
                            },
                        }],
                    },
                    bsb: {
                        value: userSuper.bsb || "",
                        mask: formMasks.bsb,
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'bsb', callback, setFormValidation);
                            },
                        }],
                    },
                    account_number: {
                        value: userSuper.accountNumber || "",
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'anyNumber', callback, setFormValidation);
                            },
                        }],
                    },
                }
                for (const key in formsDataArray.userForm) {
                    delete formsDataArray.userForm[key]
                }
                Object.assign(formsDataArray.userForm, dataArray);
            }
            formHooks(formsDataArray)

            // Keep type.resetValue so form change detection works:
            // - If user reverted to original value → resetValue = value (form not changed)
            // - Otherwise → resetValue = previous selection (form changed)
            if (eventValue === originalFundType) {
                formsData.userForm.type.resetValue = eventValue;
            } else {
                formsData.userForm.type.resetValue = previousFundType.value;
            }
            previousFundType.value = eventValue;

            if (routeName == "profile_super") {
                checkFormValidation("userForm", true);
            }
        }
        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();

            formsRefs.userForm.value.$el[0].focus();
            if (routeName == "profile_super") {
                if (files.value.length > 0) {
                    formsData.userForm.files.value = [];
                    delete formsDataArray.userForm.files.validators;
                }
                checkFormValidation("userForm", true);

            }

            // checkFormValidation('userForm', false);
            // setFormValidation('userForm', false, false);
            // setFundTypeAndAssignNewKeys(userSuper.type);
        });

        const fileDelete = async (file) => {
            try {
                await ElMessageBox.confirm(
                    `Are you sure you’d like to remove file ?`,
                    "Remove file",
                    {
                        confirmButtonText: "Remove",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--red",
                        cancelButtonClass: "el-button--grey",
                        showClose: false,
                    }
                );
                console.log("file is going to delete", file);
                await $store.dispatch("DELETE_USER_DOCUMENT", file);
                files.value.splice(file, 1);
                if (files.value.length == 0 && !formsData.userForm.files.value.length > 0) {
                    formsDataArray.userForm.files.validators = [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "gallery",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ];
                    checkFormValidation("userForm", true);
                }
            } catch (error) {
                console.log(error);
            }
        };

        const fixValidation = () => {
            // Forcing to check form validation as continue button was not working
            checkFormValidation('userForm', true);

        }
        const {
            ["onFormMaskAccept"]: onFormMaskAccept,
            checkFormValidation,
            setFormValidation,

            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            onFormMaskAccept,
            formsData,
            goBack,
            save,
            skip,
            userRole,
            pageText,
            setFundTypeAndAssignNewKeys,
            routeName,
            userSuper,
            superUserType,
            birthdayValue,
            dateConvert,
            cropperMethods,
            fileDelete,
            certPreviewModalOpen,
            certPreviewModal,
            files,
            fixValidation,
            isLocumAndSoleTrader,
            formatDate: (date) => {
                return moment(date).format('ll');
            }
        }
    },
}
</script>
